// extracted by mini-css-extract-plugin
module.exports = {"mb-20px":"_3RSTT-8r913bCzr5_IJ-YV","mb-10px":"_2Cvb1qywha-Gurn2iXIgNy","outlet-name":"_1PsyZ_aZDmRMSyI1swq9kZ"};